import { connect } from "react-redux";
import { getRootMargin } from "../../state/modules/layout/selectors";
import LazyProductImage from "../../components/ProductTile/LazyProductImage";

const mapStateToProps = state => ({
  rootMargin: getRootMargin(state)
});

export default connect(mapStateToProps)(LazyProductImage);
